/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class HarlequinGameAssets {

    // INTRO /PAYTABLE ASSETS
    public static NEW_INTRO_BACKGROUND_PLATE =  "resources/images/intro/newIntroBackgroundPlate.png";
    public static INTRO_BORDER_TILE =  "resources/images/intro/borderTile.png";
    public static INTRO_FEATURE_1 =  "nolimit/screens/images/feature1.png";
    public static INTRO_FEATURE_1_US =  "nolimit/screens/images/feature1_US.png";
    public static INTRO_FEATURE_2 =  "nolimit/screens/images/feature2.png";
    public static INTRO_FEATURE_3 =  "nolimit/screens/images/feature3.png";
    public static INTRO_FEATURE_3_US =  "nolimit/screens/images/feature3_US.png";
    public static INTRO_WOMAN =  "resources/images/intro/newWoman.png";
    public static NOLIMIT_BONUS_ANIMATION =  "resources/images/intro/NolimitBonusAnimation.json";
    public static INTRO_BUY_FEATURE_ICON =  "resources/images/intro/buyFeatureIcon.svg";
    public static PROMO_FREESPIN =  "nolimit/promo-panel/FREESPIN.png";

    public static BACK_GROUND_DARKENING = "respinSumPresentation/backgroundDarkening";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(HarlequinGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],
        main : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("harleyMultiplier", "fonts/bitmapfonts/harleyMultiplier.fnt"),
                    new BitmapFontAsset("fifthCountUp", "fonts/bitmapfonts/fifthCountUp.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("navArrow", "spine/svg/navArrow.svg"),
                    new TextureAsset("xNudgeSvg", "spine/svg/xNudge.svg")
                ],
                animations : {
                    "intro/introLogo1" : "introLogo1",
                    "intro/tile" : "tile",
                    "intro/star" : "star",
                    "intro/pice" : "pice"
                }
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),

                    new SpineAsset("wildWalker", "spine/skeleton.json"),
                    new SpineAsset("signRespin", "spine/signRespin.json"),
                    new SpineAsset("signBonus", "spine/signBonus.json"),

                    new SpineAsset("M1Spine", "spine/M1symbolAnimations.json"),
                    new SpineAsset("M2Spine", "spine/M2symbolAnimations.json"),
                    new SpineAsset("M3Spine", "spine/M3symbolAnimations.json"),
                    new SpineAsset("M4Spine", "spine/M4symbolAnimations.json"),
                    new SpineAsset("M5Spine", "spine/M5symbolAnimations.json"),


                    new SpineAsset("respinSumSpine", "spine/respinWinSumPresentation.json"),
                    new SpineAsset("bonusWinSumSpine", "spine/bonusWinSumPresentation.json"),

                    new SpineAsset("nearWin", "spine/nerWin.json"),
                    new SpineAsset("wildOmen", "spine/wildOmen.json"),

                    new SpineAsset("stackWildWinSpine", "spine/wildsymbolAnimations.json"),

                    new SpineAsset("baseGameHeads", "spine/BaseGameHeads.json"),

                    new SpineAsset("bonusIntro", "spine/bonusIntro.json"),
                    new SpineAsset("backgroundSpine", "spine/background.json"),
                    new SpineAsset("bigWinText", "spine/bigWinText.json"),

                    // New sign spines
                    new SpineAsset("middleBar", "spine/NewHeadInMiddle.json"),
                    new SpineAsset("leftBar", "spine/NewLeftTopbar.json"),
                    new SpineAsset("rightBar", "spine/NewRightTopbar.json"),

                    new SpineAsset("harlequinBonusWon", "spine/HarlequinBonusWonText.json")
                ],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "indicatorLit" : "meters/MeterHead",
                    "plusOneFs" : "displaySingns/+1",

                    // bet lines
                    "pearlPoint" : "betlines/ball",
                    "straightPearls" : "betlines/BetlinePearls1",
                    "smallCurvePearls" : "betlines/BetlinePearls2",
                    "largeCurvePearls" : "betlines/BetlinePearls3",

                    "mpMedal" : "betlines/medalion2",

                    "winStar" : "particles/star",
                    "bigWinCoin0" : "particles/gem_blue/gem_blue_",
                    "bigWinCoin1" : "particles/gem_long/gem_long_",
                    "bigWinCoin2" : "particles/gem_round/gem_round_",

                    "ember0" : "particles/ember/mainIdle1",
                    "ember1" : "particles/ember/mainIdle2",
                    "ember2" : "particles/ember/mainIdle3",

                    "respinNumber1" : "displaySingns/1_harelequinCounterDispalyBig",
                    "respinNumber2" : "displaySingns/2_harelequinCounterDispalyBig",
                    "respinNumber3" : "displaySingns/3_harelequinCounterDispalyBig",
                    "respinNumber4" : "displaySingns/4_harelequinCounterDispalyBig",

                    "textNr0" : "displaySingns/0_harelequinCounterDispaly",
                    "textNr1" : "displaySingns/1_harelequinCounterDispaly",
                    "textNr2" : "displaySingns/2_harelequinCounterDispaly",
                    "textNr3" : "displaySingns/3_harelequinCounterDispaly",
                    "textNr4" : "displaySingns/4_harelequinCounterDispaly",

                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json")
                ],
                animations : {
                    "bigWinBgStar" : "BigWin_bg1"
                }
            },
            {
                // TODO: Adding sppine resources here temporarily
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new SpineAsset("scatterSpine", "spine/scatter.json"),
                    new SpineAsset("scatterWildSpine", "spine/scatterWild.json"),

                    new SpineAsset("L1Spine", "spine/L1symbolAnimations.json"),
                    new SpineAsset("L2Spine", "spine/L2symbolAnimations.json"),
                    new SpineAsset("L3Spine", "spine/L3symbolAnimations.json"),
                    new SpineAsset("L4Spine", "spine/L4symbolAnimations.json"),
                ],
                animations : {
                    "S/S" : "B/B",
                    "S/S_spin" : "B/B",
                    "S2/S2" : "BW/BW",
                    "S2/S2_spin" : "BW/BW"
                }
            }
        ]
    };
}
